define("Modules/PageFooter", [`Module`, `module`], function (Super, Self) {
	return Super.inherit({
		namespace: Self.id,
		requires: [`Geolocation`, `Locale`],
		defaults: {
			mode: `legacy`, // legacy | ux3
			render: true,
			show: true,
			showSiteLinks: true,
			showSocialLinks: {
				desktop: true,
				mobile: true,
			},
			showAbout: {
				desktop: true,
				mobile: true,
			},
			showCreators: {
				desktop: true,
				mobile: true,
			},
			showBlog: {
				desktop: true,
				mobile: true,
			},
			showDiscover: {
				desktop: true,
				mobile: true,
			},
			showSupport: {
				desktop: true,
				mobile: true,
			},
			showPrivacy: {
				desktop: true,
				mobile: true,
			},
			showPrivacyChoices: {
				desktop: false,
				mobile: false,
			},
			showManageCookies: {
				desktop: true,
				mobile: true,
			},
			showTerms: {
				desktop: true,
				mobile: true,
			},
			showCookiePolicy: {
				desktop: true,
				mobile: true,
			},
			showDoNotSellMyInfo: {
				desktop: false,
				mobile: false,
			},
			transition: `fade`,
		},
		async prepare(setup) {
			const { Geolocation, data } = this;
			const {
				mode,
				showAbout,
				showBlog,
				showDiscover,
				showCookiePolicy,
				showCreators,
				showManageCookies,
				showPrivacy,
				showSiteLinks,
				showSocialLinks,
				showSupport,
				showTerms,
			} = setup;

			let { showPrivacyChoices, showDoNotSellMyInfo } = setup;

			const geo = await Geolocation.get();

			if (geo && geo.in_us) {
				showPrivacyChoices.desktop = true;
				showPrivacyChoices.mobile = true;
				showDoNotSellMyInfo.desktop = true;
				showDoNotSellMyInfo.mobile = true;
			}

			this.assign(data, {
				mode,
				showAbout,
				showBlog,
				showDiscover,
				showCookiePolicy,
				showCreators,
				showDoNotSellMyInfo,
				showManageCookies,
				showPrivacy,
				showPrivacyChoices,
				showSiteLinks,
				showSocialLinks,
				showSupport,
				showTerms,
			});
		},
		constructor(setup) {
			const { container, data, Locale } = this;
			const { mode } = data;

			container.setAttribute(`mode`, mode);
			this.addClass(`hide-ios`);
			this.addClass(`hide-android`);

			Locale.get({
				fireImmediately: true,
				subscribe: (locale) => {
					const { available, selected } = locale;
					const localeElement = this.get(`.choose-language-text`);

					if (this.isObject(localeElement)) {
						localeElement.innerHTML = `${selected.uniqueLabel}`;

						if (available.length < 2) {
							this.hide({ selector: `[action="choose-language"]` });
						}
					}
				},
			});

			// TODO: Determine if mobile app links should only displayed on associated devices
		},
		listeners: [
			{
				event: `click`,
				filter: `[action]`,
				handler({ currentTarget }) {
					const action = currentTarget.getAttribute(`action`);

					switch (action) {
						case `manage-cookies`:
							this.App.loadOverlay({
								type: `ManageCookies`,
								setup: {
									backgroundOpacity: 0.6,
								},
							});
							break;

						case `choose-language`:
							this.Locale.loadLanguageSelectionOverlay();
							break;
					}
				},
			},
		],
	});
});

define("Modules/PageFooter.templates",["handlebars"], function(Handlebars) {

this["Templates"] = this["Templates"] || {};

this["Templates"]["Modules/PageFooter/main"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div class=\"right\"> <div class=\"company-column\"> <h4>Company</h4> "
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,(depth0 != null ? lookupProperty(depth0,"showCreators") : depth0),{"name":"with","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":270},"end":{"line":1,"column":349}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,(depth0 != null ? lookupProperty(depth0,"showAbout") : depth0),{"name":"with","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":350},"end":{"line":1,"column":425}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,(depth0 != null ? lookupProperty(depth0,"showBlog") : depth0),{"name":"with","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":426},"end":{"line":1,"column":489}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,(depth0 != null ? lookupProperty(depth0,"showDiscover") : depth0),{"name":"with","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":490},"end":{"line":1,"column":547}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,(depth0 != null ? lookupProperty(depth0,"showSupport") : depth0),{"name":"with","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":548},"end":{"line":1,"column":624}}})) != null ? stack1 : "")
    + " </div> <div class=\"legal-column\"> <h4>Legal</h4> "
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,(depth0 != null ? lookupProperty(depth0,"showCookiePolicy") : depth0),{"name":"with","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":674},"end":{"line":1,"column":753}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,(depth0 != null ? lookupProperty(depth0,"showManageCookies") : depth0),{"name":"with","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":754},"end":{"line":1,"column":846}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,(depth0 != null ? lookupProperty(depth0,"showPrivacy") : depth0),{"name":"with","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":847},"end":{"line":1,"column":916}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,(depth0 != null ? lookupProperty(depth0,"showPrivacyChoices") : depth0),{"name":"with","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":917},"end":{"line":1,"column":1002}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,(depth0 != null ? lookupProperty(depth0,"showDoNotSellMyInfo") : depth0),{"name":"with","hash":{},"fn":container.program(20, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1003},"end":{"line":1,"column":1097}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,(depth0 != null ? lookupProperty(depth0,"showTerms") : depth0),{"name":"with","hash":{},"fn":container.program(22, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1098},"end":{"line":1,"column":1163}}})) != null ? stack1 : "")
    + " </div> </div> ";
},"2":function(container,depth0,helpers,partials,data) {
    return " <a href=\"//creators.tixr.com\">Sell on Tixr</a> ";
},"4":function(container,depth0,helpers,partials,data) {
    return " <a href=\"//creators.tixr.com/about\">About</a> ";
},"6":function(container,depth0,helpers,partials,data) {
    return " <a href=\"//blog.tixr.com\">Blog</a> ";
},"8":function(container,depth0,helpers,partials,data) {
    return " <a href=\"/\">Discover</a> ";
},"10":function(container,depth0,helpers,partials,data) {
    return " <a href=\"//support.tixr.com\">Fan Support</a> ";
},"12":function(container,depth0,helpers,partials,data) {
    return " <a href=\"/cookie-policy\">Cookie Policy</a> ";
},"14":function(container,depth0,helpers,partials,data) {
    return " <a href=\"#\" action=\"manage-cookies\">Manage Cookies</a> ";
},"16":function(container,depth0,helpers,partials,data) {
    return " <a href=\"/privacy\">Privacy Policy</a> ";
},"18":function(container,depth0,helpers,partials,data) {
    return " <a href=\"/privacy-choices\">Privacy Choices</a> ";
},"20":function(container,depth0,helpers,partials,data) {
    return " <a href=\"/do-not-sell-my-info\">Do Not Sell My Info</a> ";
},"22":function(container,depth0,helpers,partials,data) {
    return " <a href=\"/termsofservice\">Terms</a> ";
},"24":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div class=\"social-links\"> <a href=\"//www.x.com/tixr_\" aria-label=\"tixr x\">"
    + alias2(lookupProperty(helpers,"getIcon").call(alias1,"x",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":1873},"end":{"line":1,"column":1888}}}))
    + "</a> <a href=\"//www.instagram.com/tixrhq\" aria-label=\"tixr instagram\">"
    + alias2(lookupProperty(helpers,"getIcon").call(alias1,"instagram",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":1958},"end":{"line":1,"column":1981}}}))
    + "</a> <a href=\"//www.facebook.com/tixrhq\" aria-label=\"tixr facebook\">"
    + alias2(lookupProperty(helpers,"getIcon").call(alias1,"facebook",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":2049},"end":{"line":1,"column":2071}}}))
    + "</a> </div> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, alias3=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"parallax\"> <hr class=\"divider wide\" /> <div class=\"top-content\"> <div class=\"left\"> <div class=\"logo\"> <a href=\"/\" aria-label=\"home\">"
    + alias2(lookupProperty(helpers,"getIcon").call(alias1,"tixr",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":145},"end":{"line":1,"column":163}}}))
    + "</a> </div> </div> "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showSiteLinks") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":182},"end":{"line":1,"column":1185}}})) != null ? stack1 : "")
    + " </div> <hr class=\"divider\" /> <div class=\"bottom-content\"> <div class=\"left\"> <a href=\"//apps.apple.com/us/app/tixr-event-tickets/id843423849\" class=\"button small ux4 tertiary light-alt\" theme=\""
    + alias2(alias3((depth0 != null ? lookupProperty(depth0,"theme") : depth0), depth0))
    + "\">"
    + alias2(lookupProperty(helpers,"getIcon").call(alias1,"apple-logo",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":1391},"end":{"line":1,"column":1415}}}))
    + " iOS</a> <a href=\"//play.google.com/store/apps/details?id=com.tixr.tixr&pli=1\" class=\"button small ux4 tertiary light-alt\" theme=\""
    + alias2(alias3((depth0 != null ? lookupProperty(depth0,"theme") : depth0), depth0))
    + "\">"
    + alias2(lookupProperty(helpers,"getIcon").call(alias1,"android-logo",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":1556},"end":{"line":1,"column":1582}}}))
    + " Android</a> </div> <div class=\"right\"> <a href=\"#\" action=\"choose-language\" aria-label=\"choose a language\">"
    + alias2(lookupProperty(helpers,"getIcon").call(alias1,"earth",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":1690},"end":{"line":1,"column":1709}}}))
    + " <span class=\"choose-language-text\" translate=\"no\"></span></a> "
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,(depth0 != null ? lookupProperty(depth0,"showSocialLinks") : depth0),{"name":"with","hash":{},"fn":container.program(24, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1772},"end":{"line":1,"column":2092}}})) != null ? stack1 : "")
    + " </div> </div> </div>";
},"useData":true});

return this["Templates"];

});
//# sourceMappingURL=PageFooter.js.map